import React, {useEffect} from 'react';
import Routes from './routes/Routes';
import './App.css';
import {LanguageContextProvider} from './context/language';
import store from './redux/store';
import {Provider} from 'react-redux';
import AppAlert from './components/atoms/AppAlert';

function App() : JSX.Element {
  useEffect(() => {
    //@ts-ignore
    FreshworksWidget('hide', 'launcher');
  }, []);
  return (
    <Provider store={store}>
      <LanguageContextProvider>
        <Routes />
        <AppAlert />
      </LanguageContextProvider>
    </Provider>
  );
}

export default App;
